import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_SETUP_WIZARD = "/setup_wizard";
export const REDIRECT_TO_QUICK_START = "/configuration";

export const configuration = {
  id: "Configuration",
  label: "Configuration",
  icon: "managementApp",
  items: [
    {
      label: "Configuration",
      path: "/configuration",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Admin_Console,
        role: Roles.Read,
      },
      topLabel: <></>,
    },
  ],
  path: "/configuration",
  isSingle: true,
};
